<template>
  <layout>
    <template v-slot:title>Disconnect</template>
    <div class="preamble">
      <strong
        >This will log you out from Sharedo and remove all stored configuration
        and settings.</strong
      >
    </div>
    <form-buttons>
      <button type="button" class="btn btn-primary" @click="resetClicked">
        Reset
      </button>
      <router-link to="/" class="btn btn-secondary">Cancel</router-link>
    </form-buttons>
  </layout>
</template>
<script>
import auth from "@/services/auth/authService";
import sharedoSettings from "@/services/sharedo/sharedoSettingsService";
import sharedoCapabilities from "@/services/sharedo/sharedoCapabilitiesService";

const resetClicked = async function() {
  this.logDebug("Reseting sharedo settings.");

  var vm = this;

  try {
    auth.logout();
    this.logInfo("User has successfully logged out.");
  } catch (error) {
    this.logError("Error logging out.", { error });
  }

  sharedoSettings.clear();
  sharedoCapabilities.clear();
  this.logDebug("Sharedo settings cleared.")

  vm.$store.commit("disconnected");
  this.logInfo("Add-in disconnected from sharedo.");

  this.$router.push({ path: "/", query: { nologon: true } });
};

export default {
  methods: {
    resetClicked,
  },
};
</script>
<style lang="scss" scoped>
.preamble {
  margin-bottom: 20px;
}
</style>
